<template>
    <div :class="buttonClass" class="flex-container mx-1">
        <audio-button
            v-for="item in audioItems"
            v-bind:key="item.keyIdx"
            :audio-item="item"
            :button-type="buttonType"
        ></audio-button>
    </div>
</template>

<script>
import AudioButton from '@/components/AudioButton.vue'

export default {
    name: 'AudioButtons',
    components: {
        AudioButton,
    },
    props: {
        audioItems: {
            type: Array,
        },
        buttonType: {
            type: String,
        },
    },
    computed: {
        buttonClass: function () {
            switch (this.buttonType) {
                case 'normal':
                    return 'normalbutton'
                case 'mini':
                    return 'minibutton'
                case 'button':
                    return 'minibutton'
                default:
                    return 'normalbutton'
            }
        },
    },
}
</script>

<style scoped>
.flex-container {
    display: flex;
    flex-wrap: wrap;
}
.minibutton {
    justify-content: start;
}
.normalbutton {
    justify-content: center;
}
</style>
